<template>
  <div>
    <div class="website-solution" v-show="$route.meta.showfater">
      <div class="solution-banner">
        <img alt src="@/assets/images/website/solution/banner.jpg" />
      </div>
      <div class="solution-list">
        <div class="website-container">
          <Row>
            <Col :key="item.id" class="solution-col" span="8" v-for="item in solutionList">
            <div @click="handleDetail(item.route)" class="solution-item">
              <div class="solution-name">{{ item.name }}</div>
              <div class="solution-des">{{ item.description }}</div>
              <span class="solution-tag">{{ item.tag1 }}</span>
              <span class="solution-tag">{{ item.tag2 }}</span>
            </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
      solutionList: [
        {
          id: 1,
          name: '智能工厂整体解决方案',
          description: '提供完整建设智能工厂的解决方案，从可研、整体设计到落地实施',
          tag1: '解决方案',
          tag2: '自主研发',
          route: '/solution/Intelligent-factory',
        },
        {
          id: 2,
          name: '数字化工厂解决方案',
          description: '提供基础网络建设及安防监控网络建设、数据中心机房建设、集控中心建设，打造工厂的数字化、信息化',
          tag1: '解决方案',
          tag2: '自主研发',
          route: '/solution/digital-factory',
        },
        {
          id: 3,
          name: '有色金属加工MES系统',
          description: '为有色金属加工企业提供MES生产制造执行系统  为有色金属装备制造企业提供全方面生产管理解决方案',
          tag1: '解决方案',
          tag2: '自主研发',
          route: '/solution/mes-system',
        },
        {
          id: 4,
          name: '信息化辅助系统',
          description: '为有色金属加工企业提供全流程质量检测、判定与管理一体化解决方案',
          tag1: '解决方案',
          tag2: '自主研发',
          route: '/solution/information-system',
        },
        {
          id: 5,
          name: '物流管理系统',
          description: '从有色金属加工物料、订单、库存、生产、出入库等数据统计与管理',
          tag1: '解决方案',
          tag2: '自主研发',
          route: '/solution/logistics-management',
        },
        {
          id: 6,
          name: '工业互联网+AI安全管控系统',
          description: '对不安全行为进行管控，实现双重信息预防及隐患排查，预防安全事故',
          tag1: '解决方案',
          tag2: '自主研发',
          route: '/solution/safety-control',
        },
        {
          id: 7,
          name: '机器视觉技术应用',
          description: '通过人工智能深度学习算法的支持，经过千万级真实数据积累和持续训练，可自主识别不同形态缺陷的特征，从而实现智能判定不良等功能，快速提升产线效率和良品率',
          tag1: '解决方案',
          tag2: '自主研发',
          route: '/solution/machine-vision',
        },
        {
          id: 8,
          name: '板型检测及控制系统',
          description: '有效解决带材边部板形问题边部板形好，生产稳定，提高了轧制速度和生产效率减小废边宽度，减小下游切边量，提高成材率',
          tag1: '解决方案',
          tag2: '自主研发',
          route: '/solution/plate-type',
        },
        {
          id: 9,
          name: '有色金属加工工业互联网平台建设',
          description: '构建支持有色金属加工行业企业资源泛在连接、弹性供给、高效配置的云平台打造基于工业互联网的行业服务新生态',
          tag1: '解决方案',
          tag2: '自主研发',
          route: '/solution/industrial-internet',
        },
        {
          id: 10,
          name: '有色金属加工数字化孪生技术',
          description: '对工厂全工艺流程中的物料物流、设备资产、现场环境、工作人员等进行虚拟世界仿真建模，并通过实时数据驱动的动态仿真机制，实现实时生产数据驱动的三维虚拟可视化监控',
          tag1: '解决方案',
          tag2: '自主研发',
          route: '/solution/digital-twin',
        },
      ],
    }
  },
  methods: {
    handleDetail(name) {
      // let routeData = this.$router.resolve({
      //   name,
      // })
      // window.open(routeData.href, '_blank')
      this.$router.push(name)
    },
  },
}
</script>

<style scoped lang="less">
.solution-banner {
  width: 100%;
  height: 500px;

  img {
    width: 100%;
    object-fit: cover;
  }
}

.solution-list {
  padding: 40px 0;
}

.solution-col:nth-child(3n + 1) {
  background-color: #eef7ff;
  margin-bottom: 20px;
}

.solution-col:nth-child(3n + 3) {
  background-color: #eef7ff;
  margin-bottom: 20px;
}

.solution-col:nth-child(3n + 2) {
  background-color: #f9fcff;
  margin-bottom: 20px;
}

.solution-item {
  padding: 30px 20px;
  height: 200px;
  overflow: hidden;

  &:hover {
    cursor: pointer;
    background-color: #fff;
    box-shadow: 10px 6px 10px #eef7ff;

    .solution-name,
    .solution-des {
      color: #2d8cf0;
    }
  }

  .solution-name {
    color: #000;
    font-size: 16px;
    font-weight: 900;
    line-height: 48px;
  }

  .solution-des {
    color: #666;
    margin-bottom: 20px;
    width: 100%;
    line-height: 24px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .solution-tag {
    color: #999;
    border: 1px solid #999;
    font-size: 12px;
    margin-right: 10px;
    padding: 2px 4px;
  }
}
</style>
